import { zodResolver } from '@hookform/resolvers/zod';

export const debugZodResolver: typeof zodResolver = (...args) => {
  const resolver = zodResolver(...args);
  return async (values, context, options) => {
    const result = await resolver(values, context, options);
    if (import.meta.env.DEV && Object.keys(result.errors).length > 0) {
      console.warn('[Zod Validation]', result.errors);
      console.warn('[Zod Validation]', values);
    }
    return result;
  };
};
